<template>
  <v-col class="pa-0" align="center">
    <p class="bold-h3 ml-4">
      {{ lockerMessage(lowestLockers) }}
    </p>
    <p class="body-2 ml-4" v-if="otherLockers.length">
      {{ lockerMessage(otherLockers, true) }}
    </p>
    <v-row class="pa-4" align="center" justify="center">
      <v-col
        v-for="index in nrOfLocker"
        :key="index"
        class="pa-1"
        align="center"
        justify="center"
      >
        <v-card color="primary" elevation="0" style="max-width: 250px">
          <v-col align="center" justify="center" class="pa-0">
            <p class="bold-h3">
              {{ $t("pickUplocker") + " " + index }}
            </p>

            <div v-if="isNewLocker">
              <v-row class="ma-2">
                <v-col class="pa-0 mr-1">
                  <LockerBlink
                    :locker="1 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                  />
                </v-col>
                <v-col class="pa-0 ml-1">
                  <LockerBlink
                    :locker="6 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-2">
                <v-col class="pa-0 mr-1">
                  <LockerBlink
                    :locker="2 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                    :small="true"
                  />
                  <LockerBlink
                    class="mt-2"
                    :locker="3 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                    :small="true"
                  />
                </v-col>
                <v-col class="pa-0 ml-1">
                  <LockerBlink
                    :locker="7 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-2">
                <v-col class="pa-0 mr-1">
                  <LockerBlink
                    :locker="4 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                    :small="true"
                  />
                  <LockerBlink
                    class="mt-2"
                    :locker="5 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                    :small="true"
                  />
                </v-col>
                <v-col class="pa-0 ml-1">
                  <LockerBlink
                    :locker="8 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                  />
                </v-col>
              </v-row>
            </div>

            <div v-else-if="isRydLocker">
              <v-row class="ma-2">
                <v-col class="pa-0 mr-1">
                  <LockerBlink
                    :locker="1 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                    :small="true"
                  />
                </v-col>
                <v-col class="pa-0 ml-1">
                  <LockerBlink
                    :locker="5 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                    :small="true"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-2">
                <v-col class="pa-0 mr-1">
                  <LockerBlink
                    :locker="2 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                    :small="true"
                  />
                </v-col>
                <v-col class="pa-0 ml-1">
                  <LockerBlink
                    :locker="6 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                    :small="true"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-2">
                <v-col class="pa-0 mr-1">
                  <LockerBlink
                    :locker="3 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                    :small="true"
                  />
                </v-col>
                <v-col class="pa-0 ml-1">
                  <LockerBlink
                    :locker="7 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                    :small="true"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-2">
                <v-col class="pa-0 mr-1">
                  <LockerBlink
                    :locker="4 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                    :small="true"
                  />
                </v-col>
                <v-col class="pa-0 ml-1">
                  <LockerBlink
                    :locker="8 + (index - 1) * 8"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                    :small="true"
                  />
                </v-col>
              </v-row>
            </div>

            <div v-else>
              <v-row class="ma-2">
                <v-col class="pa-0 mr-1">
                  <LockerBlink
                    :locker="1 + (index - 1) * 6"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                  />
                </v-col>
                <v-col class="pa-0 ml-1">
                  <LockerBlink
                    :locker="4 + (index - 1) * 6"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-2">
                <v-col class="pa-0 mr-1">
                  <LockerBlink
                    :locker="2 + (index - 1) * 6"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                  />
                </v-col>
                <v-col class="pa-0 ml-1">
                  <LockerBlink
                    :locker="5 + (index - 1) * 6"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-2">
                <v-col class="pa-0 mr-1">
                  <LockerBlink
                    :locker="3 + (index - 1) * 6"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                  />
                </v-col>
                <v-col class="pa-0 ml-1">
                  <LockerBlink
                    :locker="6 + (index - 1) * 6"
                    :lockers="lockerNrs"
                    :lowestLockers="lowestLockers"
                  />
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
import OrderAPI from "@/api/OrderAPI";
import { useI18n } from "vue-i18n";
import LockerBlink from "@/components/lockerImageGenerator/LockerBlink.vue";
export default {
  components: {
    LockerBlink,
  },
  props: {
    lockers: {
      type: Number,
      required: true,
    },
    lockerOrder: {
      type: Object,
      default: false,
    },
  },
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  computed: {
    isNewLocker() {
      return this.lockers % 8 == 0;
    },
    isRydLocker() {
      return this.lockers % 7 == 0;
    },
    lockerNrs() {
      return this.lockerOrder.lockerBoxes.map((e) => e.nr);
    },
    nrOfLocker() {
      return this.isRydLocker
        ? 2
        : Math.floor(this.lockers / (this.isNewLocker ? 8 : 6));
    },
    lowestLockers() {
      if (this.isRydLocker) return this.lockerNrs;
      const lowestInRange = (start, end) => {
        const inRange = this.lockerNrs.filter((n) => n >= start && n <= end);
        if (inRange.length === 0) return null;
        return Math.min(...inRange);
      };

      const result = [];

      const l1 = lowestInRange(1, this.isNewLocker ? 8 : 6);
      if (l1 !== null) result.push(l1);

      const l2 = lowestInRange(
        this.isNewLocker ? 9 : 7,
        this.isNewLocker ? 16 : 12
      );
      if (l2 !== null) result.push(l2);

      return result;
    },
    otherLockers() {
      // returns all lockers not in lowestLockers
      return this.lockerNrs.filter((l) => !this.lowestLockers.includes(l));
    },
  },

  methods: {
    lockerMessage(lockers, later) {
      const count = lockers.length;

      if (count === 1) {
        return this.t(later ? "locker_one_later" : "locker_one", {
          locker: lockers[0],
        });
      } else if (count === 2) {
        return this.t(later ? "lockers_two_later" : "lockers_two", {
          locker1: lockers[0],
          locker2: lockers[1],
        });
      } else {
        return this.t(later ? "lockers_many_later" : "lockers_many", {
          lockers: lockers.join(", "),
        });
      }
    },
  },
};
</script>
